/**
 * WHAT EACH KEY DOES — the words, not the bindings.
 *
 * The KEY itself is never in here. Which cap does what lives in `client/keymap.ts` and is guarded
 * against the dispatchers; this only says it in words. A catalogue that named the key would be the binding
 * described twice, with the copy nobody re-reads winning the day somebody rebinds one.
 */
export default {
  group_move: 'MOVEMENT',
  group_fight: 'COMBAT',
  group_screen: 'SCREEN',
  group_instrument: 'INSTRUMENTS',
  group_drone: 'DRONE',
  group_radio: 'RADIO',

  walk: 'walk',
  run: 'run',
  stealth: 'stealth: half speed, no footsteps',
  jump: 'jump',
  climb: 'climb',
  kneel: 'kneel',
  prone: 'go prone',
  cover_next: 'next cover (bounds mode)',

  drone_carry: 'take the drone out: the eye becomes the aircraft and your body stays put',
  drone_fly: 'fly: forward, back and sideways',
  drone_lift: 'climb and descend',
  drone_fast: 'full envelope; without it, half',
  drone_stow: 'back to your body: it has to be SET DOWN beside you first',
  drone_cut: 'cut the link: the drone stays PARKED where it is and you return to your body without it',

  fire: 'fire; with the can in hand, throw it',
  grenade: 'draw or stow the smoke can',
  carry: 'choose what is in your hands',
  carry_digits: '1 primary · 2 sidearm · 3+ one can per colour',
  items: 'open the pack — the wheel picks and the click uses',
  items_digits: 'with the pack open, a digit picks the stop and uses it',
  reload: 'reload',
  swap: 'switch to the sidearm and back',
  fire_mode: 'fire mode: auto or single',
  dye: 'with the can in hand, the smoke colour',
  tune: 'dial velocity, BB weight and hop',
  scope: 'sight, held (tube only)',
  turret: 'turret, inside the sight',
  zoom_cycle: 'magnification (cycles)',
  zoom_direct: 'magnification, direct',
  zoom_direct_if: 'magnification, direct, if the tube carries it',
  recentre: 're-centre the sight',
  radio_bank: 'open the set: its sixteen memories, A and B',
  radio_pick: 'in the bank: choose a memory',
  radio_put: 'in the bank: put that memory on A or on B',
  radio_program: 'in the bank: type six digits to write the frequency',
  radio_ab: 'swap which of the two memories transmits',
  talk: 'transmit by radio; the mouth is always open',

  record_note: 'what just happened: the last 12 s',
  dev_note: 'DEVELOPMENT — only with the panel (F1) open',
  group_dial: 'CALIBRATION — with the panel (F1) and its box open',
  dial_ring: 'what is being calibrated: the hand or each grip',
  dial_take: 'take/release the field prop under the crosshair',
  round_start: 'start a new round',
  reset_targets: 'reset the targets',
  takeoff: 'take off now',
  landing: 'land now',
  stock: 'stock, with the muzzle pinned',
  keyboard: 'this keyboard',
  map: 'field map',
  release_pointer: 'release the pointer',
  close_tab: 'close the tab; while playing it asks first',

  panel: 'instrument panel',
  panel_tab: 'cycle the panel pages',
  third_person: 'watch yourself from behind',
  record: 'record telemetry (stops itself after 5 min)',

  // ── the drawn board's own chrome ──────────────────────────────────────────────────────────────────
  // The two pointer buttons are named rather than drawn as caps: a mouse button has no legend to copy,
  // and `LMB` is jargon for a surface whose whole job is to answer somebody who does not know yet.
  // PROD-CLEANUP: these five have no call site — the mouse rows and the close hint are drawn with their
  // own text. Wire them or drop them; they are the only dead entries in a namespace of 55.
  click_left: 'LEFT CLICK',
  click_right: 'RIGHT CLICK',
  mouse_move: 'MOVE',
  mouse_aim: 'aim',
  // Every way out is named because the board is opened mid-match: one that closes on a key the player
  // did not find is a panel over the field with no exit.
  board_close: 'T · ESC · ✕ to close — any of the three · hover a key to read it',
};
